module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_03 (1).fe593975.png";